
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Listings = lazy(() => import('../pages/listings/page'));
const Listing = lazy(() => import('../pages/listing/page'));
const Notices = lazy(() => import('../pages/notices/page'));
const Neighborhoods = lazy(() => import('../pages/neighborhoods/page'));
const Agents = lazy(() => import('../pages/agents/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/listings',
    element: <Listings />,
  },
  {
    path: '/listing/:id',
    element: <Listing />,
  },
  {
    path: '/notices',
    element: <Notices />,
  },
  {
    path: '/neighborhoods',
    element: <Neighborhoods />,
  },
  {
    path: '/agents',
    element: <Agents />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
